
const Propagate=()=>{
    return ("{\"status\":success}")
}

export default Propagate;